import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "shift-being-created" }
const _hoisted_2 = { class: "font-bold font-size-18 mb-4" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_7 = { class: "flex mb-4 flex-col" }
const _hoisted_8 = { class: "mb-1 font-bold font-size-14" }
const _hoisted_9 = { class: "w-104" }
const _hoisted_10 = { class: "flex mb-4 flex-col" }
const _hoisted_11 = { class: "font-bold font-size-14" }
const _hoisted_12 = { class: "font-size-14 text-grey-666 mb-1" }
const _hoisted_13 = { class: "w-64" }
const _hoisted_14 = { class: "flex mb-4 flex-col" }
const _hoisted_15 = { class: "mb-1 font-bold font-size-14" }
const _hoisted_16 = { class: "w-104 flex items-center justify-between" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", null, "～", -1)
const _hoisted_18 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_20 = { class: "font-size-14 mb-4" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-2xl" }, null, -1)
const _hoisted_22 = { class: "mb-8 w-fit" }
const _hoisted_23 = {
  key: 0,
  class: "flex items-center px-2"
}
const _hoisted_24 = { class: "flex justify-center" }
const _hoisted_25 = { class: "box-avatar ml-2" }
const _hoisted_26 = { class: "span-action--active" }
const _hoisted_27 = { class: "flex items-center justify-center" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-right text-2xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Input = _resolveComponent("Input")
  const _component_Select = _resolveComponent("Select")
  const _component_DatePickerInput = _resolveComponent("DatePickerInput")
  const _component_WorkPatternShiftPlan = _resolveComponent("WorkPatternShiftPlan")
  const _component_Button = _resolveComponent("Button")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Table = _resolveComponent("Table")
  const _component_ImportOrExportShiftPlan = _resolveComponent("ImportOrExportShiftPlan")
  const _component_PopupConfirmSubmit = _resolveComponent("PopupConfirmSubmit")
  const _component_AddTargetPersonPopup = _resolveComponent("AddTargetPersonPopup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_BackPreviousPage, { onClick: _ctx.backToListShiftPlan }, null, 8, ["onClick"]),
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('shiftCreation')) + "：" + _toDisplayString(_ctx.t('signUp')), 1),
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('allAreRequiredFields')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('basicSettings')), 1),
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.t('title')), 1),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Input, {
              modelValue: _ctx.apiPostData.shift_plan_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiPostData.shift_plan_name = $event)),
              required: "",
              validated: _ctx.validated,
              "error-server": _ctx.errorServer.shift_plan_name,
              errors: _ctx.errors.shift_plan_name,
              "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.shift_plan_name = $event)),
              disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS,
              placeholder: _ctx.t('pleaseEnter')
            }, null, 8, ["modelValue", "validated", "error-server", "errors", "disabled", "placeholder"])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('targetDepartment')), 1),
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('switchUnitMemberSelectionsUpdate')), 1),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_Select, {
              "options-select": _ctx.shiftPlanOption,
              "item-text": "unit_name",
              "item-value": "unit_id",
              modelValue: _ctx.apiPostData.unit_id,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.apiPostData.unit_id = $event)),
              disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS,
              placeholder: _ctx.t('placeholderSelect'),
              validated: _ctx.validated,
              required: "",
              errors: _ctx.errors.unit_id,
              "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.unit_id = $event)),
              onChange: _cache[5] || (_cache[5] = (value, item) => _ctx.onChangeUnitId(value, item))
            }, null, 8, ["options-select", "modelValue", "disabled", "placeholder", "validated", "errors"])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('targetPeriod')), 1),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", null, [
              _createVNode(_component_DatePickerInput, {
                width: "184",
                format: "YYYY/MM/DD",
                placeholder: 'YYYY/MM/DD',
                modelValue: _ctx.apiPostData.register_start_date,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.apiPostData.register_start_date = $event)),
                validated: _ctx.validated,
                "error-server": _ctx.errorServer.register_start_date,
                required: "",
                errors: _ctx.errors.register_start_date,
                "onUpdate:errors": _cache[7] || (_cache[7] = ($event: any) => (_ctx.errors.register_start_date = $event))
              }, null, 8, ["modelValue", "validated", "error-server", "errors"])
            ]),
            _hoisted_17,
            _createVNode("div", null, [
              _createVNode(_component_DatePickerInput, {
                width: "184",
                format: "YYYY/MM/DD",
                placeholder: 'YYYY/MM/DD',
                modelValue: _ctx.apiPostData.register_end_date,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.apiPostData.register_end_date = $event)),
                validated: _ctx.validated,
                "error-server": _ctx.errorServer.register_end_date,
                required: "",
                errors: _ctx.errors.register_end_date,
                "onUpdate:errors": _cache[9] || (_cache[9] = ($event: any) => (_ctx.errors.register_end_date = $event)),
                disabled: _ctx.statusNewShift === _ctx.ITEM_STATUS
              }, null, 8, ["modelValue", "validated", "error-server", "errors", "disabled"])
            ])
          ])
        ]),
        _createVNode(_component_WorkPatternShiftPlan)
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.t('memberSelection')), 1),
        _hoisted_19,
        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('shiftPlanNote')), 1),
        _createVNode(_component_Button, {
          class: "mb-4",
          variant: "outline-primary",
          onClick: _ctx.openAddTargetPerson
        }, {
          default: _withCtx(() => [
            _hoisted_21,
            _createTextVNode(_toDisplayString(_ctx.t('addOtherMembers')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_Table, {
            headers: _ctx.membersToSubmittedHeaders,
            data: 
            _ctx.membersToSubmittedData.slice(
              (_ctx.currentPage - 1) * _ctx.itemPerPages,
              _ctx.currentPage * _ctx.itemPerPages
            )
          ,
            fixedLeft: 1,
            "is-fixed": "",
            "is-pagination": "",
            "items-per-pages": _ctx.itemPerPages,
            "record-total": _ctx.membersToSubmittedData.length,
            "current-page": _ctx.currentPage,
            "onUpdate:current-page": _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentPage = $event))
          }, {
            "data-name": _withCtx(({ item, index, dataRow }) => [
              (index !== _ctx.membersToSubmittedData.length)
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_Avatar, {
                        width: "37px",
                        height: "37px",
                        src: dataRow.photo,
                        name: dataRow.name_face_image
                      }, null, 8, ["src", "name"])
                    ]),
                    _createVNode("div", _hoisted_25, _toDisplayString(item), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            "data-action": _withCtx(({ index }) => [
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode("span", {
                    onClick: ($event: any) => (_ctx.deletePlanEmployee(index)),
                    class: [
                    _ctx.statusNewShift !== _ctx.ITEM_STATUS
                      ? 'cursor-pointer '
                      : 'pointer-events-none'
                  , "cp-icon-minus text-red-ff font-size-32 border-1 rounded-full"]
                  }, null, 10, ["onClick"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["headers", "data", "items-per-pages", "record-total", "current-page"])
        ]),
        _createVNode("div", null, [
          _createVNode(_component_Button, {
            disabled: _ctx.isDisabledBtn,
            onClick: _ctx.submitCreateOrUpdateShiftPlan
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('next')) + " ", 1),
              _hoisted_28
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.isImportOrExportShiftPlan]
    ]),
    (_ctx.isImportOrExportShiftPlan)
      ? (_openBlock(), _createBlock(_component_ImportOrExportShiftPlan, {
          key: 0,
          onOnBack: _ctx.backShiftPlanRegister
        }, null, 8, ["onOnBack"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PopupConfirmSubmit, {
      modelValue: _ctx.isShowPopupConfirmSubmit,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isShowPopupConfirmSubmit = $event)),
      onOnClose: _ctx.closeConfirmSubmit
    }, null, 8, ["modelValue", "onOnClose"]),
    (_ctx.isShowAddTargetPersonPopup)
      ? (_openBlock(), _createBlock(_component_AddTargetPersonPopup, {
          key: 1,
          modelValue: _ctx.isShowAddTargetPersonPopup,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.isShowAddTargetPersonPopup = $event)),
          onOnClose: _ctx.closeAddTargetPerson
        }, null, 8, ["modelValue", "onOnClose"]))
      : _createCommentVNode("", true)
  ], 64))
}